import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { useCopyToClipboard } from '@repo/ui/hooks/use-copy-to-clipboard';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

export type RecoveryCodeListProps = {
  recoveryCodes: string[];
};

export const RecoveryCodeList = ({ recoveryCodes }: RecoveryCodeListProps) => {
  useLocale();

  const [, copyToClipboard] = useCopyToClipboard();

  const onCopyRecoveryCodeClick = async (code: string) => {
    try {
      const result = await copyToClipboard(code);

      if (!result) {
        throw new Error(t('auth.unableToCopyRecoveryCode'));
      }

      toast.success(t('auth.recoveryCodeCopied'), {
        get description() {
          return t('auth.yourRecoveryCodeHasBeenCopiedToYourClipboard');
        },
      });
    } catch (_err) {
      toast.error(t('auth.unableToCopyRecoveryCode'), {
        get description() {
          return t('auth.weWereUnableToCopyYourRecoveryCodeTo');
        },
      });
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {recoveryCodes.map((code) => (
        <div
          className="relative rounded-lg bg-muted p-4 font-mono text-muted-foreground md:text-center"
          key={code}
        >
          <span>{code}</span>
          <div className="absolute inset-y-0 end-4 flex items-center justify-center">
            <button
              className="opacity-60 hover:opacity-80"
              onClick={() => void onCopyRecoveryCodeClick(code)}
            >
              <Copy className="h-5 w-5" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
